<!-- 用户明细页面 -->
<template>
<a-row :gutter="24" class="new-row">
  <a-col :sm="24" :md="collapsed? 0: 5" class="new-col">
    <a-card :bordered="false" class="new-tree-card">
      <!-- 按钮操作区域 -->
      <div style="background: #fff;padding-left:16px;height: 100%; margin-top: 5px">
        <a-alert type="info" :showIcon="true">
          <div slot="message">
            {{ $t('当前选择：') }}<span v-if="this.currSelected.title">{{ getCurrSelectedTitle() }}</span>
            <a v-if="this.currSelected.title" style="margin-left: 10px" @click="unselect">{{ $t('取消选择') }}</a>
          </div>
        </a-alert>
        <div style="display: flex;margin-top: 10px;">
          <a-input-search v-model="searchAreaValue" style="width:100%;margin-right: 5px;" allowClear :placeholder="$t('请输入区域名称')"/>
          <a-button type="default" @click="collapseAll">{{ $t('折叠') }}</a-button>
        </div>
        <!-- 树-->
        <a-col :md="24" :sm="24" class="new-tree-col">
          <template>
            <a-spin tip="Loading..." :spinning="areaLoading">
              <!--
                <span style="user-select: none">
                  <a-tree
                    class="my-area-select-tree"
                    @select="onSelect"     
                    :selectedKeys="selectedKeys"
                    :treeData="areaTree"
                    :checkStrictly="checkStrictly"
                    :expandedKeys="iExpandedKeys"
                    :autoExpandParent="autoExpandParent"
                    defaultExpandParent
                    @expand="onExpand">
                    <template slot="title" slot-scope="{title}">
                      <span v-if="title.indexOf(searchAreaValue) > -1">
                        {{title.substr(0, title.indexOf(searchAreaValue))}}
                      <span style="color: #32CD32">{{searchAreaValue}}</span>
                        {{title.substr(title.indexOf(searchAreaValue) + searchAreaValue.length)}}
                      </span>
                      <span v-else>{{title}}</span>
                    </template>
                  </a-tree>
                </span>
                -->
                <el-tree
                  class="filter-tree"
                  :data="areaTree"
                  :props="defaultProps"
                  :expand-on-click-node="false"
                  :filter-node-method="filterNode"
                  :check-on-click-node="true"
                  :check-strictly="checkStrictly"
                  :highlight-current="true"
                  node-key="id"
                  :current-node-key="currentNodeKey"
                  :default-expanded-keys="iExpandedKeys"
                  @node-click="nodeClick"
                  ref="areaTree">
                </el-tree>
              </a-spin>
          </template>
        </a-col>
      </div>
    </a-card>
  </a-col>
  <a-col :md="collapsed? 24: 19" :sm="24" style="position: relative;padding-left: 30px" class="new-col">
    <a-icon :type="collapsed ? 'caret-right':'caret-left'" 
      @click="collapsed = !collapsed"
      class="area-collapsed"></a-icon>
    <a-card :bordered="false" class="new-table-card">
      <!-- 查询区域 -->
      <div class="table-page-search-wrapper">
        <a-form layout="inline" @keyup.enter.native="searchQuery">
          <a-row :gutter="24">
            <a-col :xl="10" :lg="11" :md="12" :sm="24">
                <a-form-item :label="$t('日期')">
                  <a-range-picker
                    v-model="date"
                    :placeholder="[$t('查询起始时间'), $t('查询结束时间')]"
                    format="YYYY-MM-DD"
                    @change="onDateRangeChange"
                  />
                </a-form-item>
              </a-col>
              <a-col :xl="10" :lg="11" :md="12" :sm="24">
                <a-form-item :label="$t('用水量范围')">
                  <a-input-number v-model="queryParam.minValue" :min="0" :precision="2" />
                  -
                  <a-input-number v-model="queryParam.maxValue" :min="0" :precision="2" />
                  m³
                </a-form-item>
              </a-col>
            <a-col :xl="6" :lg="7" :md="8" :sm="24">
              <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                <a-button type="primary" @click="searchQuery" icon="search">{{ $t('查询') }}</a-button>
                <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{ $t('重置') }}</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <!-- table区域-begin -->
      <div class="table-operator">
        <a-button type="primary" icon="download" @click="handleExportXls($t('用水量查询'))">{{ $t('导出') }}</a-button>
      </div>
      <div class="table-fixed">
        <a-table
          ref="table"
          size="middle"
          tableLayout="fixed"
          bordered
          rowKey="userKeyId"
          :columns="columns"
          :dataSource="dataSource"
          :pagination="ipagination"
          :loading="loading"
          class="j-table-force-nowrap"
          @change="handleTableChange">
          <div slot="filterDropdown">
            <a-card>
              <a-checkbox-group @change="onColSettingsChange" v-model="settingColumns" :defaultValue="settingColumns">
                <a-row>
                  <template v-for="item in defColumns">
                    <template v-if="item.key!='rowIndex'&& item.dataIndex!='action'">
                      <a-col :span="12" :key="item.key"><a-checkbox :value="item.dataIndex">{{ item.title }}</a-checkbox></a-col>
                    </template>
                  </template>
                </a-row>
              </a-checkbox-group>
            </a-card>
          </div>
          <!--
          <span slot="action" slot-scope="text, record">
            <a @click="handleDetail(record)">详情</a>
          </span>
          -->
        </a-table>
      </div>
      <!--<meter-user-account-modal ref="modalForm" @ok="modalFormOk"></meter-user-account-modal>-->
    </a-card>
  </a-col>
</a-row>
</template>

<script>
  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import {AreaChoosetMixin} from '@/mixins/AreaChooseMixin'
  import moment from 'moment'
  import { listSize } from '@/utils/util'
  import { httpAction, putAction,getAction } from '@/api/manage'
  import { isUndefinedAndNull } from '@/utils/validate'
  import {getNextDate,getDaysBetween} from '@/utils/util'
  import Vue from 'vue'
  export default {
    name: 'MeterUserWaterUseNumList',
    mixins:[JeecgListMixin, mixinDevice,AreaChoosetMixin],
    components: {
      //MeterUserAccountModal
    },
    data () {
      return {
        description: '用水量查询页面',
        //表头
        columns:[],
        //列设置
        settingColumns:[],
        url: {
          list: "/jeecg-charge/meter/waterAnalysis/queryUserInfoByWaterUse",
          delete: "",
          deleteBatch: "",
          exportXlsUrl: "/jeecg-charge/meter/waterAnalysis/exportXlsUserInfoByWaterUse",  //导出接口
          importExcelUrl: "",
        },
        dictOptions:{},
        date: [],
        disableMixinCreated: true,
        dateType: 0,
      }
    },
    created() {
      this.$store.commit('SET_LAYOUT_TREE',true)
      this.initColumns();
      this.loadData();
      //初始化字典配置 在自己页面定义
      this.initDictConfig();
      this.loadTree();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
      // i18n：列定义使用 computed 以响应语言切换
      defColumns() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            },
            scopedSlots: {
            filterDropdown: 'filterDropdown',
            filterIcon: 'filterIcon', }
          },{
            title: this.$t('用户编号'),
            align:"center",
            dataIndex: 'userId',
            width: 150,
            ellipsis: true
          },{
            title: this.$t('用户姓名'),
            align:"center",
            dataIndex:'userName',
            width: 100,
            ellipsis: true,
          },{
            title: this.$t('表编号'),
            align:"center",
            dataIndex: 'meterId',
            width: 150,
            ellipsis: true,
          },{
            title: this.$t('用户地址'),
            align:"center",
            dataIndex: 'userAddr',
            ellipsis: true,
            customRender: (t,r,index) => {
              if(r.userAreaName){
                let i = r.userAreaName.indexOf('-');
                return r.userAreaName.slice(i+1,r.userAreaName.length)+'-'+t;
              }else{
                return t
              }
            },
          },{
            title: this.$t('用水量(m³)'),
            align:"center",
            dataIndex: 'waterUse',
            width: 100,
            ellipsis: true,
          }
          /*
          ,{
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:80,
            scopedSlots: { customRender: 'action' }
          }
          */
        ]
      },
    },
    methods: {
      loadData(arg) {
        if(!this.url.list){
          this.$message.error(this.$t('请设置url.list属性!'))
          return
        }
        // 判断时间跨度不能超过5天
        if(!this.queryParam.beginDate||!this.queryParam.beginDate) {
          //return this.$message.warning("请选择查询起止时间");
          let date = moment(new Date()).format('YYYY-MM-DD');
          this.date[0] = moment(getNextDate(date,-5),'YYYY-MM-DD');
          this.date[1] = moment(getNextDate(date,-1),'YYYY-MM-DD');
          let Start = moment(this.date[0]).format('YYYY-MM-DD');
          let End = moment(this.date[1]).format('YYYY-MM-DD');
          this.queryParam.beginDate = Start;
          this.queryParam.endDate = End;
        }
        let betweenDay = getDaysBetween(this.queryParam.beginDate,this.queryParam.endDate);
        console.log("相差天数："+betweenDay)
        if(betweenDay<0) {
          return this.$message.warning(this.$t("结束时间不能小于开始时间"));
        }else if(betweenDay>4) {
          return this.$message.warning(this.$t("查询起止时间跨度不能超过5天"));
        }

        // 增加用户余额范围查询
        if(!isUndefinedAndNull(this.queryParam.minValue)&&!isUndefinedAndNull(this.queryParam.maxValue)) {
          if(this.queryParam.minValue>this.queryParam.maxValue) {
            this.$message.error(this.$t("用水量起始值不能大于终止值"));
            return;
          }
        }
        //加载数据 若传入参数1则加载第一页的内容
        if (arg === 1) {
          this.ipagination.current = 1;
        }
        var params = this.getQueryParams();//查询条件
        this.loading = true;
        getAction(this.url.list, params).then((res) => {
          if (res.success) {
            this.dataSource = res.result.records;
            this.ipagination.total = res.result.total;
          }
          if(res.code===510){
            this.$message.warning(res.message)
          }
          this.loading = false;
        })
      },
      //列设置更改事件
      onColSettingsChange (checkedValues) {
        var key = this.$route.name+":colsettings";
        Vue.ls.set(key, checkedValues, 7 * 24 * 60 * 60 * 1000)
        this.settingColumns = checkedValues;
        const cols = this.defColumns.filter(item => {
          if(item.key =='rowIndex'|| item.dataIndex=='action'){
            return true
          }
          if (this.settingColumns.includes(item.dataIndex)) {
            return true
          }
          return false
        })
        this.columns =  cols;
      },
      initColumns(){
        //权限过滤（列权限控制时打开，修改第二个参数为授权码前缀）
        //this.defColumns = colAuthFilter(this.defColumns,'testdemo:');
        var key = this.$route.name+":colsettings";
        let colSettings= Vue.ls.get(key);
        if(colSettings===null||colSettings==undefined){
          let allSettingColumns = [];
          this.defColumns.forEach(function (item,i,array ) {
            allSettingColumns.push(item.dataIndex);
          })
          this.settingColumns = allSettingColumns;
          this.columns = this.defColumns;
        }else{
          this.settingColumns = colSettings;
          const cols = this.defColumns.filter(item => {
            if(item.key =='rowIndex'|| item.dataIndex=='action'){
              return true;
            }
            if (colSettings.includes(item.dataIndex)) {
              return true;
            }
            return false;
          })
          this.columns =  cols;
        }
      },
    }
  }
</script>
<style scoped>
  .my-area-select-tree /deep/ li .ant-tree-node-content-wrapper{
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    white-space: nowrap;
  }
</style>